module.exports = "/_next/static/images/0146d5b2700fb35369e5977662e1ef26-website-mgm-thumb-large.jpg.webp";